import React, { useEffect } from 'react';

import styled from 'styled-components';

import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import { EUISnackBarMessageType, showBasicSnackBar } from '@aquariuxfintech/aqx-trader-react-ui/snack-bar';

import { ESignUpDemoContent, useSignUpDemo } from '@aqx-core/common/services/sign-up-demo';
import { signUpDemoViewController } from '@aqx-core/common/services/sign-up-demo/controller';

import SignUpDemoCreationCompleted from './content/completed';
import SignUpDemoForm from './content/form';

const SignUpDemoScreen: FCC = () => {
  const { content } = useSignUpDemo();

  useEffect(() => {
    const onError = (message: string) => {
      showBasicSnackBar({
        message,
        messageType: EUISnackBarMessageType.ERROR
      });
    };

    signUpDemoViewController.initSignUpDemo(onError);
    return () => signUpDemoViewController.reset();
  }, []);
  return (
    <StyledContainer>
      {content === ESignUpDemoContent.FORM ? <SignUpDemoForm /> : <SignUpDemoCreationCompleted />}
    </StyledContainer>
  );
};

export default SignUpDemoScreen;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: ${ESpacing.M}px;
`;
